import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ADMIN_SECTIONS, AdminSection } from '../../component/admin-sidebar/admin-sidebar.component';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class AdminLandingComponent implements OnInit, OnDestroy {
  /** Chave i18n do título da seção ativa — exibido no header do conteúdo.
   *  Derivada da URL contra a lista canônica de seções (ADMIN_SECTIONS), pra
   *  não duplicar rótulos. Null fora de qualquer seção conhecida. */
  currentSectionLabel: string | null = null;

  /** True quando a seção ativa renderiza o próprio header (ícone+título) — aí
   *  o shell NÃO mostra o título genérico, pra não duplicar. */
  currentSectionOwnHeader = false;

  private sub?: Subscription;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.updateCurrentSection(this.router.url);
    this.sub = this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.updateCurrentSection(e.urlAfterRedirects);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private updateCurrentSection(url: string): void {
    const path = (url || '').split('?')[0].replace(/\/$/, '');
    const match: AdminSection | undefined =
      ADMIN_SECTIONS.find(s => path === s.link || path.startsWith(s.link + '/'));
    this.currentSectionLabel = match ? match.label : null;
    this.currentSectionOwnHeader = !!match?.ownHeader;
  }
}
